<template>
  <div>
  <section class="nav" style="display:block;">
    <div class="nav_wrap">
      <div class="nav_flex">
        <div class="nav-left-div">
          <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo.svg" loading="lazy" alt="" class="image-544"></a>
          
        </div>
        
      </div>
      
    </div>
    <div class="nav-shadow"></div>
    <div class="mobile-nav-div">
      <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar home w-nav">
        <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo.svg" loading="lazy" alt="" class="image-550"></a>
        
        
      </div>
      <div class="div-block-1958"></div>
    </div>
  </section>
  <section class="form-section " >
    <div class="login-box logContain" >
      <div class="enroll-slide-1" style="padding-top: 45px;">
        <div class="header-sub-div">
          <div class="enroll-header-2">Great to see you again.</div>
          <p class="enroll-sub-2">Let's get you logged in</p>
          <div class="text-block-203">New user? <router-link to="/quiz" class="link-17">take the quiz <span class="text-span-182">-&gt;</span></router-link>
          </div>
        </div>
        <div class="form-block w-form">
          <form @submit.prevent="onSubmit">
            <div class="enroll-slide-1-div-3">
              <label for="email" class="label">Email Address</label>
              <input 
                class="text-field-59 email form update w-input" 
                maxlength="256" 
                name="email" 
                data-name="Email" 
                placeholder="Enter your email" 
                type="email" 
                id="email" 
                required=""
                v-model="email"
              >
              <label for="Password" class="label">Password</label>
              <input 
                class="text-field-59 email form update w-input" 
                maxlength="256" 
                name="Password" 
                data-name="Password" 
                placeholder="Enter your password" 
                type="password" 
                id="Password" 
                required=""
                v-model="password"
              >
              <div class="enroll-form-button-div">
                <button 
                  type="submit"
                  class="enroll-form-submit-button w-button"
                  :disabled="submitted"
                >
                  <div v-if="submitted">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                      <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                      </circle>
                    </svg>
                  </div>
                  <div v-else>
                    Sign In
                  </div>
                </button>
              </div>
              <div class="text-block-203">
                Forgot Password? <router-link to="/forgot-password" class="link-17">Click here to reset <span class="text-span-182">-&gt;</span></router-link>
              </div>
            </div>
          </form>
          <div class="w-form-done" v-if="success">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail" style="display: block;" v-if="err">
            <div v-html="errmsg"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 220px;"></div>
  </section>
</div>
</template>

<script>
export default {
  name: 'LoginPage',
  props: ['baseUrl'],
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      success: false,
      err: false,
      errmsg: ""
    }
  },
  computed: {
    getUrl() {
      if (this.$route.query.page_ref) {
        return `/?page_ref=${this.$route.query.page_ref}`
      } else {
        return "/"
      }
    }
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.err = false;
      this.$axios.post(this.baseUrl + '/api/login', {
        password: this.password,
        email: this.email.toLowerCase(),
      }).then(response => {
        if (response.data.status == 'success') {
          this.$store.dispatch("doLogin", response.data);
          const pageRef = this.$route.query.page_ref || '/home';
          this.$router.push(pageRef);
        } else {
          this.submitted = false;
          this.err = true;
          this.errmsg = response.data.message;
        }
      }).catch(error => {
        console.log(error.message)
        this.submitted = false;
        this.err = true;
        this.errmsg = 'Email or password entered is incorrect. Please try again or <router-link to="/forgot-password">reset your password.</router-link>'
      });
    },
  }
}
</script>
<style scoped>
.login_section .w-layout-blockcontainer.container-12.w-container {
    max-width: 540px;
    padding: 0;
}
@media (max-width: 768px) {
    .logContain {
        max-width: 95%;
    }
}
</style>